import React from "react";
import {Dropdown} from "react-bootstrap";
import {LogOut, Settings, User} from "react-feather";
import {useAuth0} from "@auth0/auth0-react";
import {useNavigate} from "react-router-dom";


const NavbarUser = () => {
    const {user, isAuthenticated,logout} = useAuth0();

    const navigate = useNavigate();
    return (
        <>
            <Dropdown className="nav-item" align="end">
        <span className="d-inline-block d-sm-none">
          <Dropdown.Toggle as="a" className="nav-link">
            <Settings size={18} className="align-middle"/>
          </Dropdown.Toggle>
        </span>
                {isAuthenticated && (
                    <span className="d-none d-sm-inline-block">
            <Dropdown.Toggle as="a" className="nav-link">

              <img
                  src={user.picture}
                  className="avatar img-fluid rounded-circle"
                  alt={user.name}
                  style={{marginRight: 2}}
              />
              <span>{user.name} </span>
            </Dropdown.Toggle>
          </span>
                )}
                <Dropdown.Menu drop="end">
                    <Dropdown.Item user={user} onClick={() => navigate(`../userprofile`)}>
                        <User size={18} className="align-middle m-1"/>
                        Profile
                    </Dropdown.Item>
                    {isAuthenticated && <>
                        <Dropdown.Item
                            onClick={() => logout({returnTo: window.location.origin})}
                        > <LogOut size={18} className="align-middle m-1"/>
                            Sign out
                        </Dropdown.Item>
                    </>}

                </Dropdown.Menu>
            </Dropdown>
        </>
    );
};

export default NavbarUser;
